<!--      NOTE: don't mess with the nested divs, we are using them for styling-->
<div class="loader"><div class="loading-icon"><div></div><div></div><div></div></div></div>